import OrderHandler from "../OrderHandler";
import Mediator from "../../../Utilities/Mediator";
import CustomerAddress from "./CustomerAddress";
import CartItems from "./CartItems";
import DeliveryDatePicker from "./DeliveryDatePicker";
import SearchCustomer from "./ChooseCustomer/SearchCustomer";

export default class FinalizeBill {
	finalizeBill: HTMLDivElement;
	tagCode: HTMLInputElement;
	pickUpAtStraussCheckBox: HTMLInputElement;
	dateInput: HTMLDivElement;
	private readonly ORDER_ID_LENGTH: number = 14;

	constructor() {
		this.finalizeBill = document.querySelector(".bill-total");
		this.tagCode = this.finalizeBill.querySelector('.tagcode input');
		this.pickUpAtStraussCheckBox = this.finalizeBill.querySelector('#pickup');
		this.dateInput = document.querySelector('#date');

		this.init();
	}

	private init() {
		this.addTagCodeHandler();
		this.addPickedUpAtStraussEventListener();
		this.addMoreItemsButtonClickListener();
		this.addNotesChangeListener();
		this.addStoreSelectChangeListener();
		this.addTermsLinkChangeListener();
		new SearchCustomer();
		new CustomerAddress();
		new DeliveryDatePicker();

		Mediator.on("togglePickup", () => this.togglePickup());
		Mediator.on("orderUpdated", () => this.fetchOrderTotal());
	}

	private togglePickup() {
		if (this.tagCode) {
			const pickUpCheckBoxWrapper = document.querySelector(".tagcode + div > .checkbox");
			if (pickUpCheckBoxWrapper.classList.contains("checkbox--disabled")) {
				pickUpCheckBoxWrapper.classList.remove("checkbox--disabled");
				this.pickUpAtStraussCheckBox.disabled = false;
			} else {
				this.pickUpAtStraussCheckBox.disabled = true;
				pickUpCheckBoxWrapper.classList.add("checkbox--disabled");
			}
		}
	}

	private addStoreSelectChangeListener() {
		const storeSelect: HTMLSelectElement = this.finalizeBill.querySelector(".store-select select");

		if (storeSelect) {
			storeSelect.onchange = () => {
				if (storeSelect.value) {
					OrderHandler.order.storeId = storeSelect.value;
				}

				Mediator.emit("orderStateChanged");
			}
		}
	}

	private addTagCodeHandler() {
		if (this.tagCode) {
			const tagCodeErrorMessage: HTMLParagraphElement = this.finalizeBill.querySelector('input.form-input + p');

			this.tagCode.onchange = () => {
				const codeValue: number = this.tagCode.value ? Number(this.tagCode.value) : NaN;
				const isValidTagCode: boolean = this.tagCode.value.length < this.ORDER_ID_LENGTH && !isNaN(codeValue);
				if (isValidTagCode) {
					OrderHandler.order.tagCode = this.tagCode.value;
					this.tagCode.style.borderColor = "#bdbdbd";
					tagCodeErrorMessage.style.display = "none";
				} else {
					OrderHandler.order.tagCode = null;
					this.tagCode.style.borderColor = "#F00";
					tagCodeErrorMessage.style.display = "block";
				}
				Mediator.emit("orderStateChanged");
			}
		}
	}

	private addPickedUpAtStraussEventListener() {
		if (this.pickUpAtStraussCheckBox) {
			this.pickUpAtStraussCheckBox.onchange = () => {
				OrderHandler.order.pickedUpAtStrauss = this.pickUpAtStraussCheckBox.checked;
			}
		}
	}

	private addNotesChangeListener() {
		const notes: HTMLTextAreaElement = this.finalizeBill.querySelector('textarea');

		if (notes) {
			notes.onchange = () => {
				const notesValue = notes.value.trim();
				OrderHandler.order.notes = notesValue ? notesValue : null;
			}
		}
	}

	private addTermsLinkChangeListener() {
		const terms: HTMLInputElement = this.finalizeBill.querySelector("#terms");

		if (terms) {
			terms.onchange = () => {
				Mediator.emit("orderStateChanged");
			}
		}
	}

	private addMoreItemsButtonClickListener() {
		const addMoreItemsBtn: HTMLButtonElement = this.finalizeBill.querySelector('button');

		addMoreItemsBtn.onclick = () => {
			this.finalizeBill.style.display = "none";
			Mediator.emit("chooseItemDispatched");
		}
	}

	public fetchOrderTotal() {
		this.finalizeBill.style.display = "block";
		new CartItems();
		Mediator.emit("orderStateChanged");
	}

	public removeFinalizeBill() {
		this.finalizeBill.style.display = "none";
	}
}
